import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";

// material-ui icons
import Menu from "@material-ui/icons/Menu";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";

// core components
import HeaderLinks from "./HeaderLinks";
import Button from "components/CustomButtons/Button.jsx";

import headerStyle from "assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";
import { makeStyles } from "@material-ui/styles";
import AuthActionsMenu from "../AuthActionsMenu/AuthActionsMenu";

const useHeaderStyles = makeStyles(headerStyle);

function Header({ ...props }) {
  const headerClasses = useHeaderStyles();
  const classes = { ...headerClasses };

  function makeBrand() {
    // var name;
    const element = props.routes.find((prop) => {
      if (prop.NavLink) {
        prop.views.find((prop, key) => {
          if (prop.path === props.location.pathname) {
           return prop.name;
          }
          return null;
        });
      }

      if(!prop.redirect && props.location.pathname.indexOf(prop.path) > -1 ){
      // if (prop.path === props.location.pathname) {
       return prop.name;
      }

      return null;
    });
    if (element && element.name) {
      return element.name;
    } else {
      return "SEM";
    }
  }
  const { color, rtlActive } = props;
  const appBarClasses = cx({
    [classes.appBar]: true,
    [" " + classes[color]]: color,
    [classes.headerSidebarMini]: props.miniActive,
  });
  const sidebarMinimize =
    classes.sidebarMinimize +
    " " +
    cx({
      [classes.sidebarMinimizeRTL]: rtlActive
    });

  return (
    <AppBar className={appBarClasses}>
      <Toolbar className={classes.container}>
        <Hidden smDown implementation="css">
          <div className={sidebarMinimize}>
            {props.miniActive ? (
              <Button
                justIcon
                color="transparent"
                onClick={props.sidebarMinimize}
              >
                <ChevronRight className={classes.sidebarMiniIcon} />
              </Button>
            ) : (
              <Button
                justIcon
                color="transparent"
                onClick={props.sidebarMinimize}
              >
                <ChevronLeft className={classes.sidebarMiniIcon} />
              </Button>
            )}
          </div>
        </Hidden>
        <div className={classes.flex}>
          {/* Here we create navbar brand, based on route name */}
          <Button href="#" className={classes.title} color="transparent">
            {makeBrand()}
          </Button>
        </div>
        <Hidden smDown implementation="css">
          <HeaderLinks rtlActive={rtlActive} />
        </Hidden>
        <AuthActionsMenu hideSm />
        <Hidden mdUp implementation="css">
          <Button
            className={classes.appResponsive}
            color="transparent"
            justIcon
            aria-label="open drawer"
            onClick={props.handleDrawerToggle}
          >
            <Menu />
          </Button>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool
};

export default Header;

// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx
